'use client';

import Link from 'next/link';
import { MessageCircle, Globe } from 'lucide-react';
import { Display, Reveal, GlassCard, PinkButton } from '../ui';

const footerCols = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '/features' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Sign Up', href: '/register' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Contact', href: '/contact' },
      // TODO(links): real docs / community URLs.
      { label: 'Documentation', href: '#' },
      { label: 'Support', href: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Cookie Policy', href: '/cookie-policy' },
    ],
  },
];

export default function FinalCtaFooter() {
  return (
    <>
      <section className="relative overflow-hidden px-6 py-28 text-center">
        <Reveal className="mx-auto max-w-[1280px]">
          <GlassCard className="border-mk-pink/20 px-10 py-20 shadow-mk-neon-lg">
            <Display className="mb-8 text-5xl sm:text-6xl md:text-7xl">
              Your footage deserves to be found.
            </Display>
            <PinkButton href="/register" size="lg">
              Get Started Free
            </PinkButton>
          </GlassCard>
        </Reveal>
        <div className="pointer-events-none absolute bottom-0 left-1/2 -z-10 h-[300px] w-[800px] -translate-x-1/2 rounded-full bg-mk-pink/10 blur-[100px]" />
      </section>

      <footer className="w-full border-t border-white/10 bg-mk-void px-6 py-16">
        <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-12 md:grid-cols-4">
          <div>
            <div className="mb-6 font-mk-display text-3xl text-mk-ink">RECLIPT</div>
            <p className="mb-6 font-mk-body text-sm text-mk-muted">
              Building the cinematic age of video search. One moment at a time.
            </p>
            <div className="flex gap-4">
              {/* TODO(links): real social profiles. */}
              <a href="#" aria-label="Community" className="text-mk-muted transition-colors hover:text-mk-pink">
                <MessageCircle className="h-5 w-5" />
              </a>
              <a href="#" aria-label="Website" className="text-mk-muted transition-colors hover:text-mk-pink">
                <Globe className="h-5 w-5" />
              </a>
            </div>
          </div>
          {footerCols.map((col) => (
            <div key={col.title} className="space-y-4">
              <h4 className="font-mk-label text-xs font-bold uppercase tracking-[0.18em] text-mk-pink">
                {col.title}
              </h4>
              {col.links.map((l) => (
                <Link
                  key={l.label}
                  href={l.href}
                  className="block font-mk-body text-mk-muted transition-colors hover:text-mk-teal"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          ))}
        </div>
        <div className="mx-auto mt-16 max-w-[1280px] border-t border-white/10 pt-8 text-center font-mk-body text-sm text-mk-muted opacity-80">
          © {new Date().getFullYear()} Reclipt. All rights reserved. Built for the
          cinematic age.
        </div>
      </footer>
    </>
  );
}
